<template>
  <div>
    <div class="tile">
      <div class="form-inline">
        <b-form-input type="month" v-model="filterFormModel.period" class="mr-1" @change="load"></b-form-input>
        <admin-user-select v-if="$store.state.user.role !== 'sales'" :model="filterFormModel" attribute="sales" role-filter="sales" @change="load" :place-holder="$t('selectSales')" class="mr-1"></admin-user-select>
        <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
        <button @click="reset" class="btn btn-secondary mr-1">Reset</button>
        <button @click="exportExcel" class="btn btn-primary mr-1" :disabled="!items.length && !details.length">
          <i class="fa fa-download"></i> {{ $t('exportExcel') }}
        </button>
      </div>
    </div>

    <div class="tile">
      <div class="table-responsive c-template-table">
        <table class="table table-hover table-bordered text-center">
          <caption class="text-center text-uppercase font-weight-bold" style="caption-side: top; color: #000;">
            {{ $t('reportTitle') }} {{ monthLabel }}
          </caption>
          <thead>
            <tr>
              <th>{{ $t('region') }}</th>
              <th>{{ $t('salesPerson') }}</th>
              <th>1. CallioN</th>
              <th>1*. CallioN*</th>
              <th>2. CallioE</th>
              <th>3. CallioA</th>
              <th>4. CallioU</th>
              <th>{{ $t('totalRevenue') }}</th>
              <th>{{ $t('target') }}</th>
              <th>{{ $t('kpiRate') }}</th>
              <th>{{ $t('note') }}</th>
              <th>{{ $t('trialRegistered') }}</th>
              <th>{{ $t('trialTarget') }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="region in regions">
              <tr v-for="(item, index) in region.employees" :key="item.userId">
                <td v-if="index === 0" :rowspan="region.employees.length" class="align-middle font-weight-bold">
                  {{ region.office }}
                </td>
                <td class="text-left">{{ item.name }}</td>
                <td class="text-right">{{ item.new | numFormat }}</td>
                <td class="text-right">{{ item.newOther | numFormat }}</td>
                <td class="text-right">{{ item.extend | numFormat }}</td>
                <td class="text-right">{{ item.user | numFormat }}</td>
                <td class="text-right">{{ item.upgrade | numFormat }}</td>
                <td class="text-right">{{ item.total | numFormat }}</td>
                <td class="text-right">{{ item.target | numFormat }}</td>
                <td class="text-right">{{ kpiRate(item) }}</td>
                <td>{{ item.trialTarget > 0 ? $t('probation') : '' }}</td>
                <td class="text-right">{{ item.trialRegistered | numFormat }}</td>
                <td class="text-right">{{ item.trialTarget | numFormat }}</td>
              </tr>
              <tr :key="region.office + '-subtotal'" class="font-weight-bold" style="background-color: #d9edf7;">
                <td colspan="2" class="text-left">{{ $t('subtotal') }} {{ region.office }}</td>
                <td class="text-right">{{ region.subtotal.new | numFormat }}</td>
                <td class="text-right">{{ region.subtotal.newOther | numFormat }}</td>
                <td class="text-right">{{ region.subtotal.extend | numFormat }}</td>
                <td class="text-right">{{ region.subtotal.user | numFormat }}</td>
                <td class="text-right">{{ region.subtotal.upgrade | numFormat }}</td>
                <td class="text-right">{{ region.subtotal.total | numFormat }}</td>
                <td class="text-right">{{ region.subtotal.target | numFormat }}</td>
                <td class="text-right">{{ rate(region.subtotal.total, region.subtotal.target) }}</td>
                <td></td>
                <td class="text-right">{{ region.subtotal.trialRegistered | numFormat }}</td>
                <td class="text-right">{{ region.subtotal.trialTarget | numFormat }}</td>
              </tr>
            </template>
            <tr v-if="items.length" class="font-weight-bold text-danger" style="background-color: #fcf8e3;">
              <td colspan="2" class="text-left">{{ $t('grandTotal') }}</td>
              <td class="text-right">{{ grandTotal.new | numFormat }}</td>
              <td class="text-right">{{ grandTotal.newOther | numFormat }}</td>
              <td class="text-right">{{ grandTotal.extend | numFormat }}</td>
              <td class="text-right">{{ grandTotal.user | numFormat }}</td>
              <td class="text-right">{{ grandTotal.upgrade | numFormat }}</td>
              <td class="text-right">{{ grandTotal.total | numFormat }}</td>
              <td class="text-right">{{ grandTotal.target | numFormat }}</td>
              <td class="text-right">{{ rate(grandTotal.total, grandTotal.target) }}</td>
              <td></td>
              <td class="text-right">{{ grandTotal.trialRegistered | numFormat }}</td>
              <td class="text-right">{{ grandTotal.trialTarget | numFormat }}</td>
            </tr>
            <tr v-if="!items.length">
              <td colspan="13" class="text-danger">{{ $t('noData') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="tile">
      <div class="table-responsive c-template-table">
        <table class="table table-hover table-bordered text-center kpi-detail-table">
          <caption class="text-uppercase font-weight-bold" style="caption-side: top; color: #000;">
            {{ $t('detailTitle') }} {{ monthLabel }}
          </caption>
          <thead>
            <tr>
              <th class="align-middle">STT</th>
              <th class="align-middle">{{ $t('clientName') }}</th>
              <th class="align-middle">{{ $t('domain') }}</th>
              <th class="align-middle">{{ $t('source') }}</th>
              <th class="align-middle">Sales</th>
              <th class="align-middle">{{ $t('orderType') }}</th>
              <th class="align-middle">{{ $t('planName') }}</th>
              <th class="align-middle">{{ $t('userPrice') }}</th>
              <th class="align-middle">{{ $t('userLimit') }}</th>
              <th class="align-middle">{{ $t('numberOfUserToBuy') }}</th>
              <th class="align-middle">{{ $t('monthCount') }}</th>
              <th class="align-middle">{{ $t('expireTime') }}</th>
              <th class="align-middle">{{ $t('discount') }}</th>
              <th class="align-middle">{{ $t('totalAmount') }}</th>
              <th class="align-middle">{{ $t('status') }}</th>
              <th class="align-middle">{{ $t('createTime') }}</th>
              <th class="align-middle">{{ $t('confirmTime') }}</th>
              <th class="align-middle">{{ $t('activeTime') }}</th>
              <th class="align-middle">{{ $t('extendAgainTime') }}</th>
              <th class="align-middle">{{ $t('monthsSinceActive') }}</th>
              <th class="align-middle">{{ $t('monthsSinceReExtend') }}</th>
              <th class="align-middle">{{ $t('note') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in details" :key="index"
              :style="row.isReExtend ? 'background-color: #dff0d8;' : ''">
              <td class="align-middle">{{ index + 1 }}</td>
              <td class="text-left align-middle">{{ row.companyName }}</td>
              <td class="text-left align-middle">{{ row.domain }}</td>
              <td class="text-left align-middle">{{ row.source }}</td>
              <td class="text-left align-middle">{{ row.sales }}</td>
              <td class="text-left align-middle">{{ row.loai }}</td>
              <td class="text-left align-middle">{{ row.planName }}</td>
              <td class="text-right align-middle">{{ row.userPrice | numFormat }}</td>
              <td class="text-right align-middle">{{ row.userLimit | numFormat }}</td>
              <td class="text-right align-middle">{{ row.numberOfUserToBuy | numFormat }}</td>
              <td class="text-right align-middle">{{ row.monthCount }}</td>
              <td class="align-middle">{{ fmtTime(row.expireTime) }}</td>
              <td class="text-right align-middle">{{ row.discountAmount | numFormat }}</td>
              <td class="text-right align-middle">{{ row.total | numFormat }}</td>
              <td class="align-middle">{{ row.confirmed ? $t('confirmed') : $t('pending') }}</td>
              <td class="align-middle">{{ fmtTime(row.createTime) }}</td>
              <td class="align-middle">{{ fmtTime(row.confirmTime) }}</td>
              <td class="align-middle">{{ fmtTime(row.activeTime) }}</td>
              <td class="align-middle">
                <span v-if="row.extendAgainTime">{{ fmtTime(row.extendAgainTime) }}</span>
                <span v-else>-</span>
              </td>
              <td class="text-right align-middle">{{ row.monthsSinceActive }}</td>
              <td class="text-right align-middle">{{ row.monthsSinceReExtend }}</td>
              <td class="text-left align-middle">{{ row.note }}</td>
            </tr>
            <tr v-if="!details.length">
              <td colspan="20" class="text-danger">{{ $t('noDetail') }}</td>
            </tr>
            <tr v-if="details.length" class="font-weight-bold" style="background-color: #fcf8e3;">
              <td colspan="12" class="text-left align-middle">{{ $t('detailGrandTotal') }}</td>
              <td class="text-right align-middle">{{ detailTotal.discountAmount | numFormat }}</td>
              <td class="text-right text-danger align-middle">{{ detailTotal.total | numFormat }}</td>
              <td colspan="8"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import AdminUserSelect from '@/components/AdminUserSelect';

export default {
  components: { AdminUserSelect },
  data() {
    return {
      items: [],
      details: [],
      filterFormModel: { period: moment().format('YYYY-MM'), sales: null },
    }
  },
  computed: {
    monthLabel() {
      return moment(this.filterFormModel.period, 'YYYY-MM').format('MM/YYYY');
    },
    regions() {
      let map = {};
      let order = [];
      this.items.forEach(item => {
        let office = item.office || this.$t('unknownRegion');
        if (!map[office]) {
          map[office] = { office, employees: [], subtotal: this.emptyTotal() };
          order.push(office);
        }
        map[office].employees.push(item);
        this.accumulate(map[office].subtotal, item);
      });
      order.forEach(office => {
        map[office].employees.sort((a, b) => b.total - a.total);
      });
      return order.map(office => map[office]).sort((a, b) => a.office.localeCompare(b.office));
    },
    grandTotal() {
      let total = this.emptyTotal();
      this.items.forEach(item => this.accumulate(total, item));
      return total;
    },
    detailTotal() {
      return this.details.reduce((acc, row) => {
        acc.discountAmount += row.discountAmount || 0;
        acc.total += row.total || 0;
        return acc;
      }, { discountAmount: 0, total: 0 });
    }
  },
  methods: {
    load() {
      let [year, month] = this.filterFormModel.period.split('-');
      let params = { month: parseInt(month), year: parseInt(year) };
      if (this.filterFormModel.sales) {
        params.sales = this.filterFormModel.sales;
      }
      let loader = this.$loading.show();
      Promise.all([
        this.$service.get('/report/kpi-revenue', { params }),
        this.$service.get('/report/kpi-revenue-detail', { params }),
      ]).then(([revenue, detail]) => {
        this.items = revenue.data;
        this.details = detail.data;
      }).finally(() => {
        loader.hide();
      });
    },
    reset() {
      this.filterFormModel.period = moment().format('YYYY-MM');
      this.filterFormModel.sales = null;
      this.load();
    },
    fmtTime(t) {
      return t ? moment(t).format('DD/MM/YYYY HH:mm:ss') : '';
    },
    emptyTotal() {
      return { new: 0, newOther: 0, extend: 0, user: 0, upgrade: 0, total: 0, target: 0, trialRegistered: 0, trialTarget: 0 };
    },
    accumulate(acc, item) {
      acc.new += item.new;
      acc.newOther += item.newOther;
      acc.extend += item.extend;
      acc.user += item.user;
      acc.upgrade += item.upgrade;
      acc.total += item.total;
      acc.target += item.target;
      acc.trialRegistered += item.trialRegistered;
      acc.trialTarget += item.trialTarget;
    },
    rate(total, target) {
      if (!target) {
        return '-';
      }
      return (total / target * 100).toFixed(2) + '%';
    },
    // Sales có target KH dùng thử (Thử việc) thì tính tỷ lệ đạt KPI theo KH dùng thử, còn lại theo doanh thu
    kpiRate(item) {
      if (item.trialTarget > 0) {
        return this.rate(item.trialRegistered, item.trialTarget);
      }
      return this.rate(item.total, item.target);
    },
    xlsxFillRow(row, argb, count) {
      for (let c = 1; c <= count; c++) {
        row.getCell(c).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb } };
      }
    },
    xlsxBorderRange(sheet, r1, r2, c1, c2) {
      let thin = { style: 'thin', color: { argb: 'FFBFBFBF' } };
      for (let r = r1; r <= r2; r++) {
        let row = sheet.getRow(r);
        for (let c = c1; c <= c2; c++) {
          let cell = row.getCell(c);
          cell.border = { top: thin, left: thin, bottom: thin, right: thin };
          cell.alignment = Object.assign({ vertical: 'middle' }, cell.alignment || {});
        }
      }
    },
    async exportExcel() {
      let money = '#,##0';
      let workbook = new Excel.Workbook();

      // Sheet 1: Doanh thu KPI theo nhân viên (kèm subtotal từng phòng + tổng cả nước)
      let sheet = workbook.addWorksheet(this.$t('sheetRevenue'));
      sheet.columns = [
        { header: this.$t('region'), key: 'office', width: 16 },
        { header: this.$t('salesPerson'), key: 'name', width: 22 },
        { header: '1. CallioN', key: 'new', width: 15, style: { numFmt: money } },
        { header: '1*. CallioN*', key: 'newOther', width: 15, style: { numFmt: money } },
        { header: '2. CallioE', key: 'extend', width: 15, style: { numFmt: money } },
        { header: '3. CallioA', key: 'user', width: 15, style: { numFmt: money } },
        { header: '4. CallioU', key: 'upgrade', width: 15, style: { numFmt: money } },
        { header: this.$t('totalRevenue'), key: 'total', width: 16, style: { numFmt: money } },
        { header: this.$t('target'), key: 'target', width: 16, style: { numFmt: money } },
        { header: this.$t('kpiRate'), key: 'kpiRate', width: 12 },
        { header: this.$t('note'), key: 'note', width: 14 },
        { header: this.$t('trialRegistered'), key: 'trialRegistered', width: 14 },
        { header: this.$t('trialTarget'), key: 'trialTarget', width: 14 },
      ];
      this.regions.forEach(region => {
        region.employees.forEach(item => {
          sheet.addRow({
            office: region.office,
            name: item.name,
            new: item.new || 0,
            newOther: item.newOther || 0,
            extend: item.extend || 0,
            user: item.user || 0,
            upgrade: item.upgrade || 0,
            total: item.total || 0,
            target: item.target || 0,
            kpiRate: this.kpiRate(item),
            note: item.trialTarget > 0 ? this.$t('probation') : '',
            trialRegistered: item.trialRegistered || 0,
            trialTarget: item.trialTarget || 0,
          });
        });
        let subRow = sheet.addRow({
          office: this.$t('subtotal') + ' ' + region.office,
          new: region.subtotal.new,
          newOther: region.subtotal.newOther,
          extend: region.subtotal.extend,
          user: region.subtotal.user,
          upgrade: region.subtotal.upgrade,
          total: region.subtotal.total,
          target: region.subtotal.target,
          kpiRate: this.rate(region.subtotal.total, region.subtotal.target),
          trialRegistered: region.subtotal.trialRegistered,
          trialTarget: region.subtotal.trialTarget,
        });
        subRow.font = { bold: true };
        this.xlsxFillRow(subRow, 'FFD9EDF7', 13);
      });
      if (this.items.length) {
        let totalRow = sheet.addRow({
          office: this.$t('grandTotal'),
          new: this.grandTotal.new,
          newOther: this.grandTotal.newOther,
          extend: this.grandTotal.extend,
          user: this.grandTotal.user,
          upgrade: this.grandTotal.upgrade,
          total: this.grandTotal.total,
          target: this.grandTotal.target,
          kpiRate: this.rate(this.grandTotal.total, this.grandTotal.target),
          trialRegistered: this.grandTotal.trialRegistered,
          trialTarget: this.grandTotal.trialTarget,
        });
        totalRow.font = { bold: true, color: { argb: 'FFC00000' } };
        this.xlsxFillRow(totalRow, 'FFFCF8E3', 13);
      }
      sheet.getRow(1).font = { bold: true };
      sheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      this.xlsxFillRow(sheet.getRow(1), 'FFF2F2F2', 13);
      sheet.views = [{ state: 'frozen', ySplit: 1 }];
      this.xlsxBorderRange(sheet, 1, sheet.rowCount, 1, 13);

      // Sheet 2: Chi tiết đơn hàng tính KPI
      let detail = workbook.addWorksheet(this.$t('sheetDetail'));
      detail.columns = [
        { header: 'STT', key: 'stt', width: 6 },
        { header: this.$t('clientName'), key: 'companyName', width: 26 },
        { header: this.$t('domain'), key: 'domain', width: 22 },
        { header: this.$t('source'), key: 'source', width: 14 },
        { header: 'Sales', key: 'sales', width: 20 },
        { header: this.$t('orderType'), key: 'loai', width: 14 },
        { header: this.$t('planName'), key: 'planName', width: 12 },
        { header: this.$t('userPrice'), key: 'userPrice', width: 12, style: { numFmt: money } },
        { header: this.$t('userLimit'), key: 'userLimit', width: 12 },
        { header: this.$t('numberOfUserToBuy'), key: 'numberOfUserToBuy', width: 12 },
        { header: this.$t('monthCount'), key: 'monthCount', width: 10 },
        { header: this.$t('expireTime'), key: 'expireTime', width: 20 },
        { header: this.$t('discount'), key: 'discountAmount', width: 14, style: { numFmt: money } },
        { header: this.$t('totalAmount'), key: 'total', width: 16, style: { numFmt: money } },
        { header: this.$t('status'), key: 'status', width: 12 },
        { header: this.$t('createTime'), key: 'createTime', width: 20 },
        { header: this.$t('confirmTime'), key: 'confirmTime', width: 20 },
        { header: this.$t('activeTime'), key: 'activeTime', width: 20 },
        { header: this.$t('extendAgainTime'), key: 'extendAgainTime', width: 20 },
        { header: this.$t('monthsSinceActive'), key: 'monthsSinceActive', width: 12 },
        { header: this.$t('monthsSinceReExtend'), key: 'monthsSinceReExtend', width: 12 },
        { header: this.$t('note'), key: 'note', width: 28 },
      ];
      this.details.forEach((row, index) => {
        let r = detail.addRow({
          stt: index + 1,
          companyName: row.companyName,
          domain: row.domain,
          source: row.source,
          sales: row.sales,
          loai: row.loai,
          planName: row.planName,
          userPrice: row.userPrice || 0,
          userLimit: row.userLimit || 0,
          numberOfUserToBuy: row.numberOfUserToBuy || 0,
          monthCount: row.monthCount || 0,
          expireTime: this.fmtTime(row.expireTime),
          discountAmount: row.discountAmount || 0,
          total: row.total || 0,
          status: row.confirmed ? this.$t('confirmed') : this.$t('pending'),
          createTime: this.fmtTime(row.createTime),
          confirmTime: this.fmtTime(row.confirmTime),
          activeTime: this.fmtTime(row.activeTime),
          extendAgainTime: row.extendAgainTime ? this.fmtTime(row.extendAgainTime) : '-',
          monthsSinceActive: row.monthsSinceActive,
          monthsSinceReExtend: row.monthsSinceReExtend,
          note: row.note,
        });
        if (row.isReExtend) {
          this.xlsxFillRow(r, 'FFDFF0D8', 22);
        }
      });
      if (this.details.length) {
        let totalRow = detail.addRow({
          companyName: this.$t('detailGrandTotal'),
          discountAmount: this.detailTotal.discountAmount,
          total: this.detailTotal.total,
        });
        totalRow.font = { bold: true, color: { argb: 'FFC00000' } };
        this.xlsxFillRow(totalRow, 'FFFCF8E3', 22);
      }
      detail.getRow(1).font = { bold: true };
      detail.getRow(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      this.xlsxFillRow(detail.getRow(1), 'FFF2F2F2', 22);
      detail.views = [{ state: 'frozen', ySplit: 1 }];
      this.xlsxBorderRange(detail, 1, detail.rowCount, 1, 22);

      let buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
        `doanh-thu-kpi-${this.filterFormModel.period}.xlsx`);
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        reportTitle: 'Revenue report by employee',
        region: 'Region',
        salesPerson: 'Sales person',
        selectSales: 'Select sales person',
        totalRevenue: 'Total revenue',
        target: 'Target',
        kpiRate: 'KPI rate',
        note: 'Note',
        trialRegistered: 'Registered trial customers',
        trialTarget: 'Trial customer target',
        subtotal: 'Subtotal',
        grandTotal: 'Grand total',
        probation: 'Probation',
        unknownRegion: 'Unknown',
        noData: 'No KPI data for this month',
        exportExcel: 'Export Excel',
        sheetRevenue: 'KPI revenue',
        sheetDetail: 'Order detail',
        detailGrandTotal: 'Grand total',
        detailTitle: 'KPI order detail',
        clientName: 'Client / company',
        domain: 'Domain',
        source: 'Source',
        orderType: 'Type',
        planName: 'Plan',
        userPrice: 'Price/user',
        userLimit: 'Max users',
        numberOfUserToBuy: 'Extra users',
        monthCount: 'Months',
        expireTime: 'Expire time',
        discount: 'Discount',
        totalAmount: 'Total',
        status: 'Status',
        createTime: 'Created at',
        confirmTime: 'Confirmed at',
        activeTime: 'Activated at',
        extendAgainTime: 'Contract renewal at',
        monthsSinceActive: 'Months since activation',
        monthsSinceReExtend: 'Months since contract renewal',
        confirmed: 'Confirmed',
        pending: 'Pending',
        noDetail: 'No KPI order this month',
      },
      vi: {
        reportTitle: 'Báo cáo doanh thu theo nhân viên tháng',
        region: 'Khu vực',
        salesPerson: 'Nhân viên kinh doanh',
        selectSales: 'Chọn nhân viên kinh doanh',
        totalRevenue: 'Tổng doanh thu',
        target: 'Target',
        kpiRate: 'Tỷ lệ đạt KPI',
        note: 'Ghi chú',
        trialRegistered: 'Khách hàng đăng ký dùng thử',
        trialTarget: 'Target khách hàng dùng thử',
        subtotal: 'Tổng doanh thu',
        grandTotal: 'Cả nước',
        probation: 'Thử việc',
        unknownRegion: 'Chưa xác định',
        noData: 'Chưa có dữ liệu KPI cho tháng này',
        exportExcel: 'Xuất dữ liệu',
        sheetRevenue: 'Doanh thu KPI',
        sheetDetail: 'Chi tiết KPI',
        detailGrandTotal: 'Tổng cộng',
        detailTitle: 'Chi tiết đơn hàng tính KPI tháng',
        clientName: 'Tên khách hàng / công ty',
        domain: 'Tên miền',
        source: 'Nguồn',
        orderType: 'Loại',
        planName: 'Tên gói',
        userPrice: 'Giá/user',
        userLimit: 'Số user tối đa',
        numberOfUserToBuy: 'Số user mua thêm',
        monthCount: 'Số tháng',
        expireTime: 'Ngày hết hạn',
        discount: 'Giảm giá',
        totalAmount: 'Tổng',
        status: 'Tình trạng',
        createTime: 'Thời gian tạo',
        confirmTime: 'Thời gian xác nhận',
        activeTime: 'Thời gian kích hoạt',
        extendAgainTime: 'Thời gian tái ký',
        monthsSinceActive: 'Số tháng kể từ khi kích hoạt',
        monthsSinceReExtend: 'Số tháng kể từ khi tái ký',
        confirmed: 'Đã xác nhận',
        pending: 'Chờ xác nhận',
        noDetail: 'Chưa có đơn tính KPI cho tháng này',
      }
    }
  }
}
</script>

<style scoped>
.c-template-table table.table thead th {
  background-color: #f2f2f2 !important;
}

.kpi-detail-table th,
.kpi-detail-table td {
  white-space: nowrap;
}
</style>